<template>
  <div class="verificode-wrap">
    <div class="code-wrap" :class="{ mb: mb }">
      <input
        class="input code"
        :class="{ mb: mb, changeb: code }"
        type="text"
        :placeholder="$t($loginLangPrefix(inputCodePlaceholder))"
        v-model="code"
        @keyup.enter="next()"
        @input="codeInput"
        @blur="codeBlur"
      />
      <img
        class="codeimg"
        :class="{ mb: mb }"
        v-show="codeSrc"
        :src="codeSrc"
        @click="getVerify()"
      />
    </div>
  </div>
</template>
<script>
import api from "../js/api";

export default {
  name: "codewrap",
  props: {
    name: { type: String, default: "" },
    type: { type: String, default: "" },
    reg: { type: String, default: "" },
    mb: { type: String, default: "" },
    // inputCodePlaceholder: {
    //  type:String,default:'userSign.inputCode'
    // }
  },
  inject:['inputCodePlaceholder'],

  data() {
    return {
      code: "",
      codeSrc: "",
      codeError: "",
    };
  },
  components: {},
  methods: {
    codeInput() {
      if (!this.code) {
        this.codeError = this.$t(this.$loginLangPrefix("userSign.codeError"));
      } else {
        this.codeError = "";
      }
      this.$emit("changeCode", this.code);
      this.$emit("changeCodeError", this.codeError);
    },
    codeBlur() {
      // if (this.code && !this.reg) {
      //     api.checkVerify(this.code).then((data) => {
      //         this.codeError = '';
      //         this.$emit('changeCodeError', this.codeError);
      //     }).catch((response) => {
      //         this.codeError = this.$t(this.$loginLangPrefix('userSign.codeError'));
      //         this.$emit('changeCodeError', this.codeError);
      //     });
      // }
    },
    getVerify() {
      if (this.type === "phone") {
        api.mobileCaptcha(this.name).then((data) => {
          this.codeSrc = data.captcha;
        });
      } else {
        api.emailCaptcha(this.name).then((data) => {
          this.codeSrc = data.captcha;
        });
      }
      // if (this.reg && this.name) {
      //     api.emailCaptcha(this.name).then((data) => {
      //         this.codeSrc = data.captcha;
      //     });
      // } else {
      //     this.codeSrc = api.getVerify();
      // }
    },
    next() {
      this.$emit("btnSure");
    },
  },

  watch: {
    // codeError(val) {
    //     this.$emit('changeCodeError', val);
    // },
    name(val) {
      if (val) {
        this.getVerify();
      }
    },
  },

  beforeMount() {},

  mounted() {
    // this.codeSrc = this.getVerify();
    this.getVerify();
    console.log(this.inputCodePlaceholder,'inputCodePlaceholder')
  },

  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@function rem($n) {
  @return ($n * 1rem / 50);
}
.verificode-wrap {
  div,
  input {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    outline: none;
    border: 0;
    line-height: 1;
  }
  form {
    display: inline;
  }
  .input {
    border-bottom: 1px solid #e3e3e3;
    font-size: 16px;
    font-family: "RobotoRegular";
    font-weight: normal;
    color: rgba(23, 23, 23, 1);
    padding-bottom: 5px;
    box-sizing: border-box;
  }
  .code-wrap {
    position: relative;
    width: 100%;
    font-size: 0;
    margin-top: 20px;
    &.mb {
      margin-top: rem(20);
    }
    .code {
      display: inline-block;
      width: 230px;
      vertical-align: bottom;
      margin-right: 20px;
      &.mb {
        width: rem(230);
        margin-right: rem(20);
      }
      &.changeb {
        border-bottom: 1px solid #9d1dff;
      }
    }
    .codeimg {
      display: inline-block;
      cursor: pointer;
      width: 70px;
      height: 34px;
      border-radius: 4px;
      vertical-align: bottom;
      &.mb {
        width: rem(70);
        height: rem(34);
        border-radius: rem(4);
      }
    }
  }
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: rgba(181, 181, 181, 1);
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: rgba(181, 181, 181, 1);
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: rgba(181, 181, 181, 1);
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: rgba(181, 181, 181, 1);
  }
}
</style>
